export default theme => ({
    childrenContainer: {
        '& > form': {
            display: 'flex',
            flex: '1',
            height: 'auto',
        },
        display: 'flex',
        flex: '1',
        height: '100%',
        padding: '0px'
    },
    childrenContainerMata: {
        '@media screen and (max-width: 431px)': {
            justifyContent: 'flex-start',
        },
        boxShadow: 'none',
        display: 'grid',
        justifyContent: 'end',
    },
    contentContainer: {
        borderRadius: '3px',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    },
    helpText: {
        color: 'grey',
        fontSize: '12px',
        fontStyle: 'italic'
    },
    logo: {
        width: '176px;',
    },
    MATALogo: {
        width: '150px'
    },
    rbccmOnline: {
        color: '#006AC3',
        fontSize: '20px',
        fontWeight: '500',
        height: '24px',
        letterSpacing: '0',
        lineHeight: '24px',
        width: '136px'
    },
    rbccmOnlineContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '33px',
        justifyContent: 'space-between',
        width: '136px',
    },
    rbccmOnlineDivider: {
        backgroundColor: '#FFC72C',
        height: '3px',
        width: '40px'
    },
    registrationContainer: {
        '@media screen and (max-width: 320px)': {
            minHeight: '25vh',
            padding: '0px'
        },
        borderRadius: '8px',
        boxShadow: 'none',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '30vh',
        padding: '32px'
    },
    title: {
        color: '#003168',
        fontFamily: 'RBCDisplay Regular',
        fontSize: '34px',
        fontWeight: '400',
        letterSpacing: '0',
        lineHeight: '38px',
        whiteSpace: 'pre-line'
    },
    titleHeader: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    titleMata: {
        color: '#003168',
        fontFamily: 'RBCDisplay Regular',
        fontSize: '32px',
        fontWeight: '400',
        letterSpacing: '0',
        lineHeight: '38px',
        whiteSpace: 'pre-line'
    },
    verbiage: {
        color: '#60666D',
        fontSize: '16px',
        fontWeight: '400',
        letterSpacing: '0',
        paddingTop: '16px',
        whiteSpace: 'pre-line'
    }
})
